<template>
  <div class="py-8">
    <div class="flex call-widget position-fixed bottom-0 start-0">
      <a href="tel:+903926330000" class="btn" aria-label="Call Salamis Bay Conti Hotel">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          fill="#25d366"
          viewBox="0 0 24 24"
        >
          <path
            d="M20.487 15.14l-3.562-1.584c-.379-.168-.816-.056-1.109.279l-1.631 1.892c-2.664-1.434-4.79-3.56-6.224-6.224l1.892-1.631c.334-.293.447-.73.279-1.109L8.86 3.513c-.262-.588-.914-.894-1.54-.752l-3.5.789c-.518.116-.91.517-1.024 1.034-.427 2.009-.012 6.548 5.413 11.973 4.013 4.013 7.369 5.532 9.93 5.532.758 0 1.468-.08 2.044-.233.518-.114.919-.506 1.034-1.024l.789-3.5c.142-.625-.164-1.278-.752-1.54z"
          />
          <path
            d="M20.487 15.14l-3.562-1.584c-.379-.168-.816-.056-1.109.279l-1.631 1.892c-2.664-1.434-4.79-3.56-6.224-6.224l1.892-1.631c.334-.293.447-.73.279-1.109L8.86 3.513c-.262-.588-.914-.894-1.54-.752l-3.5.789c-.518.116-.91.517-1.024 1.034-.427 2.009-.012 6.548 5.413 11.973 4.013 4.013 7.369 5.532 9.93 5.532.758 0 1.468-.08 2.044-.233.518-.114.919-.506 1.034-1.024l.789-3.5c.142-.625-.164-1.278-.752-1.54z"
            fill="none"
            stroke="#ffffff"
            stroke-width="1"
          />
        </svg>
      </a>
    </div>
  </div>
</template>

<style scoped>
.call-widget {
  z-index: 999; /* Ensures the widget is always on top */
  padding-bottom: 1%;
  padding-left: 1%;
  display: none;
}
@media (max-width: 768px) {
  .call-widget {
    display: flex;
    padding-bottom: 70px;
  }
}
/* Phones: 70px higher, staying above the WhatsApp icon (WPWidget.vue). */
@media (max-width: 600px) {
  .call-widget {
    padding-bottom: 140px;
  }
}
</style>
  